import { IntegrationPurchase, MyIntegrationsType } from '../models'

export const getIntegrationPurchaseBuyerData = (purchase: IntegrationPurchase) => {
  const buyer = purchase.buyer_data
  if (buyer.use_company_name) { return buyer.company_name }
  return buyer.user
}

export const getBuyerDataOrdered = (a: IntegrationPurchase, b: IntegrationPurchase) => {
  return a.buyer_data.email.length - b.buyer_data.email.length
}

export const getIntegrationsFiltered = (filterText: string, oldList: MyIntegrationsType[]): MyIntegrationsType[] => {
  let newList = oldList
  if (filterText) {
    const text = filterText.toLowerCase()
    newList = newList.filter(integration => {
      return (
        integration.integration_code?.toLowerCase().includes(text) ||
        integration.intergation_initial?.toLowerCase().includes(text) ||
        `${integration.compensated_amount}`?.toLowerCase().includes(text) ||
        `${integration.purchase_amount}`?.toLowerCase().includes(text)
      )
    })
  }
  return newList
}

export const getIntegrationPurchasesFiltered = (
  filterText: string, oldList: IntegrationPurchase[]
): IntegrationPurchase[] => {
  let newList = oldList

  if (filterText) {
    const text = filterText.toLowerCase()
    newList = newList.filter(purchase => {
      return (
        getIntegrationPurchaseBuyerData(purchase)?.toLowerCase().includes(text) ||
        purchase.buyer_data.email?.toLowerCase().includes(text) ||
        purchase.name?.toLowerCase().includes(text)
      )
    })
  }
  return newList
}
